import React from 'react';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import { generatePath, useHistory, useParams } from 'react-router-dom';

import { updateQueue } from 'flow/actions/pbx-actions';
import Loading from 'flow/components/ui-components/Loading';
import Page from 'flow/components/Setting/Page';
import SettingSelectableItem from 'flow/components/ui-components/SettingSelectableItem';
import useAppContext from 'flow/hooks/useAppContext';
import { PbxParams } from 'flow/types/Params';
import { routes } from 'flow/types/routes';

import { StrategyState } from 'flow/utils';

const PbxCallStrategyEdit = () => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const history = useHistory();
    const { queueKey } = useParams<PbxParams>();
    const queue = useAppSelector((state) =>
        state.pbx.getIn(['queues', queueKey]),
    );

    if (!queue?.has('settings')) {
        return <Loading />;
    }

    const navigateBack = () => {
        history.push(
            generatePath(routes['pbx.queues.queueKey.settings.callstrategy'], {
                queueKey,
            }),
        );
    };

    const handleClick = (queueCallStrategy: string) => {
        dispatch(
            updateQueue(queueKey, {
                queueCallStrategy,
            }),
        );
        navigateBack();
    };

    return (
        <Page
            header={i18next.t('Queue.Settings.List.CallStrategy')}
            onClickBack={navigateBack}
        >
            <div>
                {queue
                    .getIn(['settings', 'queueCallStrategies'])
                    .map((strategy: string) => (
                        <SettingSelectableItem
                            key={`strategy-item-${strategy}`}
                            value={strategy}
                            onClick={handleClick}
                            selected={queue.get('queueCallStrategy')}
                        >
                            {i18next.t(
                                `Queue.CallStrategy.Item.${StrategyState[strategy].value}`,
                            )}
                        </SettingSelectableItem>
                    ))}
            </div>
        </Page>
    );
};

export default PbxCallStrategyEdit;
